import Cookies from "universal-cookie"
import setCurrencyCookie from "@Currency/functions/setCurrencyCookie"

export default function setDefaultCurrencyIfNoneSet() {
    const cookie = new Cookies();
    if (!cookie.get('currency')) {
        setCurrencyCookie('EUR')
    }
}